var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocalShipping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "local_shipping"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1650_13133",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 33
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    y: 0.511719,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1650_13133)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "local_shipping_2",
    d: "M7.58316 25.9992C6.61283 25.9992 5.79006 25.6602 5.11486 24.9821C4.43964 24.3041 4.10203 23.4807 4.10203 22.512H2.25586V9.33254C2.25586 8.71888 2.46141 8.20649 2.87253 7.79538C3.28364 7.38427 3.79604 7.17871 4.40973 7.17871H22.0508V11.9992H25.1277L29.7431 18.2043V22.512H27.5892C27.5892 23.4807 27.2496 24.3041 26.5704 24.9821C25.8911 25.6602 25.0663 25.9992 24.096 25.9992C23.1257 25.9992 22.3029 25.6602 21.6277 24.9821C20.9524 24.3041 20.6148 23.4807 20.6148 22.512H11.0764C11.0764 23.4864 10.7368 24.3112 10.0575 24.9864C9.3783 25.6616 8.55351 25.9992 7.58316 25.9992ZM7.58919 24.6659C8.18919 24.6659 8.69817 24.4569 9.11613 24.039C9.53408 23.621 9.74306 23.112 9.74306 22.512C9.74306 21.912 9.53408 21.4031 9.11613 20.9851C8.69817 20.5672 8.18919 20.3582 7.58919 20.3582C6.98919 20.3582 6.48023 20.5672 6.06229 20.9851C5.64434 21.4031 5.43536 21.912 5.43536 22.512C5.43536 23.112 5.64434 23.621 6.06229 24.039C6.48023 24.4569 6.98919 24.6659 7.58919 24.6659ZM3.58919 21.1787H4.45076C4.64049 20.5907 5.02681 20.0847 5.60973 19.6608C6.19264 19.2368 6.85246 19.0249 7.58919 19.0249C8.29177 19.0249 8.94306 19.2326 9.54306 19.6479C10.1431 20.0633 10.5379 20.5736 10.7277 21.1787H20.7174V8.51204H4.40973C4.20459 8.51204 4.01656 8.59751 3.84563 8.76844C3.67467 8.9394 3.58919 9.12743 3.58919 9.33254V21.1787ZM24.102 24.6659C24.702 24.6659 25.211 24.4569 25.629 24.039C26.0469 23.621 26.2559 23.112 26.2559 22.512C26.2559 21.912 26.0469 21.4031 25.629 20.9851C25.211 20.5672 24.702 20.3582 24.102 20.3582C23.502 20.3582 22.993 20.5672 22.5751 20.9851C22.1572 21.4031 21.9482 21.912 21.9482 22.512C21.9482 23.112 22.1572 23.621 22.5751 24.039C22.993 24.4569 23.502 24.6659 24.102 24.6659ZM22.0508 18.512H28.3328L24.4097 13.3325H22.0508V18.512Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalShipping);
export default __webpack_public_path__ + "static/media/local-shipping.343f4d4ea3978ad1702c92fe5a6ba265.svg";
export { ForwardRef as ReactComponent };